//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
export default {
  name: 'MyDialog',
  props: {
    modelValue: null,
    title: {
      type: String,
      default: ''
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50%'
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    notHeader: {
      type: Boolean,
      default: false
    },
    top: {
      type: String,
      default: '15vh'
    },
    draggable: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
    showFullSceen: {
      type: Boolean,
      default: false
    },
    autoFullScreen: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isShow: null,
      isShowFooter: false,
      contentSlots: {},
      isFullSceen: false
    };
  },
  watch: {
    modelValue: {
      handler: function handler(newVal) {
        this.isShow = newVal;
      },
      deep: true,
      immediate: true
    }
  },
  mounted: function mounted() {
    this.isShow = this.modelValue;
    if (this.autoFullScreen) {
      this.isFullSceen = true;
    }
    this.contentSlots = this.$slots;
    if (this.contentSlots.footer) {
      this.isShowFooter = true;
    }
  },
  methods: {
    close: function close() {
      this.isShow = false;
      this.$emit('update:modelValue', this.isShow);
    },
    onFullSceen: function onFullSceen() {
      this.isFullSceen = !this.isFullSceen;
    }
  }
};